import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SessionService } from './session-service';

// Member plate-photo review, backed by the plate-inbox Lambda (deploy/plate-inbox).
// Admin routes need the signed-in admin's token; the Lambda checks it against an
// admin-only dev2 API endpoint. fetch, not HttpClient, so the app interceptors
// don't rewrite the AWS URL.
export interface PendingPlatePhoto {
  id: string; // "REG/ident"
  registration: string;
  imageUrl: string;
  make: string;
  model: string;
  colour: string;
  yearSeen: string;
  credit: string;
  submittedAt: number; // unix seconds
  matchYear?: string;
}

@Injectable({ providedIn: 'root' })
export class PlatePhotoReviewService {
  constructor(private session: SessionService) {}

  private get base(): string {
    return (environment.plateInboxUrl || '').replace(/\/$/, '');
  }

  private async call(method: string, path: string, body?: any): Promise<any> {
    const res = await fetch(this.base + path, {
      method,
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + this.session.getToken(),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  }

  public pending(): Promise<PendingPlatePhoto[]> {
    return this.call('GET', '/admin/pending');
  }

  public approve(id: string): Promise<any> {
    return this.call('POST', '/admin/approve', { id });
  }

  public reject(id: string): Promise<any> {
    return this.call('POST', '/admin/reject', { id });
  }

  // Public: approved member photos for one plate, in the timeline photo shape.
  public async approvedFor(reg: string): Promise<any[]> {
    if (!this.base || !reg) return [];
    const res = await fetch(`${this.base}/photos?reg=${encodeURIComponent(reg)}`);
    if (!res.ok) return [];
    return res.json();
  }
}
